/*******************************************************************************
 * BuyingDecision Step Actions and Reducer
 */

import {
	ActionMap,
	FormContext_Action_Payload,
} from '@/components/forms/FormContext';
import { ReplaceInPersonFormState, StepMap } from '../../constants';

export const BuyingDecisionStepActions = {
	ADD_BUYING_CRITERIA: 'ADD_BUYING_CRITERIA',
	REMOVE_BUYING_CRITERIA: 'REMOVE_BUYING_CRITERIA',
} as const;

export type BuyingDecisionStepAction = keyof typeof BuyingDecisionStepActions;

export interface BuyingDecisionStepActionPayload
	extends FormContext_Action_Payload<StepMap> {
	[BuyingDecisionStepActions.ADD_BUYING_CRITERIA]: string;
	[BuyingDecisionStepActions.REMOVE_BUYING_CRITERIA]: string;
}

export type BuyingDecisionStepActionMap =
	ActionMap<BuyingDecisionStepActionPayload>[keyof ActionMap<BuyingDecisionStepActionPayload>];

export const isBuyingDecisionStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is BuyingDecisionStepActionMap =>
	action.type in BuyingDecisionStepActions;

export const buyingDecisionStepReducer = (
	state: ReplaceInPersonFormState,
	action: BuyingDecisionStepActionMap,
): ReplaceInPersonFormState => {
	switch (action.type) {
		case BuyingDecisionStepActions.ADD_BUYING_CRITERIA:
			return {
				...state,
				buyingCriteria: [...state.buyingCriteria, action.payload],
			};
		case BuyingDecisionStepActions.REMOVE_BUYING_CRITERIA:
			return {
				...state,
				buyingCriteria: state.buyingCriteria.filter(
					(criteria) => criteria !== action.payload,
				),
			};
		default:
			return state;
	}
};

export const isValid = (state: ReplaceInPersonFormState): boolean => {
	return state.buyingCriteria.length > 0;
};
